import type {RegistrationWizardStepToken} from "../tracking/track_registration_wizard_events";
import {RegistrationFlowStep} from "../types/RegistrationFlowStep";

interface IRegistrationWizardStep {
    step: RegistrationFlowStep;
    number: number;
    token: RegistrationWizardStepToken;
}

export const REGISTRATION_WIZARD_STEPS: IRegistrationWizardStep[] = [
    {step: RegistrationFlowStep.REGISTRATION, number: 1, token: "auth"},
    {step: RegistrationFlowStep.PHONE_COMPLETION, number: 2, token: "auth_phone"},
    {step: RegistrationFlowStep.PHONE_VERIFICATION, number: 2, token: "phone_verify"},
    {step: RegistrationFlowStep.NAME_COMPLETION, number: 3, token: "auth_name"}
];

export const REGISTRATION_WIZARD_STEP_COUNT = Math.max(...REGISTRATION_WIZARD_STEPS.map(({number}) => number));
import type {RegistrationWizardStepToken} from "../tracking/track_registration_wizard_events";
import {RegistrationFlowStep} from "../types/RegistrationFlowStep";

interface IRegistrationWizardStep {
    step: RegistrationFlowStep;
    number: number;
    token: RegistrationWizardStepToken;
}

export const REGISTRATION_WIZARD_STEPS: IRegistrationWizardStep[] = [
    {step: RegistrationFlowStep.REGISTRATION, number: 1, token: "auth"},
    {step: RegistrationFlowStep.PHONE_COMPLETION, number: 2, token: "auth_phone"},
    {step: RegistrationFlowStep.PHONE_VERIFICATION, number: 2, token: "phone_verify"},
    {step: RegistrationFlowStep.NAME_COMPLETION, number: 3, token: "auth_name"}
];

export const REGISTRATION_WIZARD_STEP_COUNT = Math.max(...REGISTRATION_WIZARD_STEPS.map(({number}) => number));
